<template>
  <div class="funPages">
    <div class="title">
      <img src="../assets/img/new/title_4.png" />
    </div>

    <div class="content">
      <div style="display: flex; justify-content: center; width: 100%">
        <img
          src="../assets/img/new/txt_3.png"
          style="width:90%; margin-bottom: 5%"
        />
      </div>

      <div class="flex">
        <img
          src="../assets/img/new/img5.png"
          style="height: 7vw; width: auto"
        />
        <img
          src="../assets/img/new/link_1.png"
          @click="
            toUrl(
              `https://www.facebook.com/CashFrenzyCasinoNetmarble`,
              'facebook'
            )
          "
          style="height: 3.3vw; width: auto"
        />
      </div>
      <div class="flex">
        <img
          src="../assets/img/new/img4.png"
          style="height: 7vw; width: auto"
        />
        <img
          src="../assets/img/new/link_2.png"
          @click="toUrl(`https://m.me/cashfrenzycasinonetmarble`, 'messenger')"
          style="height: 3.3vw; width: auto"
        />
      </div>
      <div class="flex">
        <img
          src="../assets/img/new/img3.png"
          style="height: 7vw; width: auto"
        />
        <img
          src="../assets/img/new/link_3.png"
          @click="
            toUrl(
              `https://www.instagram.com/cashfrenzycasinonetmarble/`,
              'instagram'
            )
          "
          style="height: 3.3vw; width: auto"
        />
      </div>
      <div class="flex">
        <img
          src="../assets/img/new/img2.png"
          style="height: 7vw; width: auto"
        />
        <img
          src="../assets/img/new/link_4.png"
          @click="toUrl(`https://bit.ly/CashFrenzyYouTube`, 'youtube')"
          style="height: 3.3vw; width: auto"
        />
      </div>
      <div class="flex">
        <img
          src="../assets/img/new/img1.png"
          style="height: 7vw; width: auto"
        />
        <img
          src="../assets/img/new/link_5.png"
          @click="toUrl(`https://twitter.com/cash_frenzy`, 'twitter')"
          style="height: 3.3vw; width: auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "fan-pages",
  methods: {
    toUrl(url, type) {
      axios({
        url: `/phoenix/click`,
        method: "POST",
        data: {
          login_user_id: this.login_user_id,
          share_user_id: this.share_user_id,
          device_type: this.platform,
          date: moment()
            .utc()
            .format("YYYY-MM-DD HH:ss:mm"),
          timestamp: new Date().valueOf(),
          url: window.location.href,
          to_url: url,
          button_type: type,
          language: navigator.language,
          user_device: navigator.userAgent,
          performance_navigation_type: window.performance.navigation.type,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(() => {
          window.location.href = url;
        })
        .catch(() => {
          window.location.href = url;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.funPages {
  margin: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    img {
      width: 100%;
    }
  }
  .content {
    width: 90vw;
    padding: 10% 0;
    background: url("../assets/img/new/bg_2.png") no-repeat center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;

    .flex {
      margin-top: 1%;
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      margin-left: 7vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fan-pages.vue